<template>
        <a-card :bordered="false">
            <div class="table-operator">
                <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
            </div>

            <a-table
                    :columns="columns"
                    :data-source="data"
                    :defaultExpandAllRows="true"
                    :pagination="false"
                    :key="tableKey"
            >
        <span slot="serial" slot-scope="text, record, index">
          {{ table.pageSize*(table.pageNumber-1) + index + 1 }}
        </span>
                <span slot="status" slot-scope="text">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
        </span>
                <span slot="description" slot-scope="text">
          <ellipsis :length="4" tooltip>{{ text }}</ellipsis>
        </span>

                <span slot="action" slot-scope="text, record">
          <template>
            <a @click="edit(record.id)"><a-icon type="edit" /> 修改</a>
            <a-divider type="vertical" />
            <a-popconfirm
                    title="是否删除该角色?"
                    ok-text="删除"
                    cancel-text="取消"
                    @confirm="del(record.id)"
            >
              <a href="#"><a-icon type="delete" /> 删除</a>
            </a-popconfirm>
          </template>
        </span>
            </a-table>
            <a-pagination
                    show-size-changer
                    :default-current="table.pageNumber"
                    :defaultPageSize="table.pageSize"
                    :total="table.total"
                    @showSizeChange="onShowSizeChange"
                    @change="tablePaginationChange"
                    style="float:right; margin-top:20px;"
            />
            <div style="clear:both"></div>

            <create-form
                    ref="createModal"
                    :visible="visible"
                    :loading="confirmLoading"
                    :model="mdl"
                    :key="formKey"
                    @cancel="handleCancel"
                    @ok="handleOk"
            />
        </a-card>
</template>

<script>

import { getRoleList, roleAdd, roleUpdate, roleDelete, getRoleInfo } from '@/api/permission/role/index'

import CreateForm from './modules/CreateRole'

const columns = [
    {
        title: '序号',
        width: '80px',
        scopedSlots: { customRender: 'serial' },
        align: 'center'
    },
    {
        title: '角色名称',
        dataIndex: 'name',
        align: 'center'
    },
    // {
    //  title: '菜单权限',
    //  dataIndex: 'menus',
    //  align: 'center'
    // },
    // {
    //  title: '操作权限',
    //  dataIndex: 'permission',
    //  align: 'center'
    // },
    // {
    //  title: '更新时间',
    //  dataIndex: 'updatedAt',
    //  sorter: true
    // },
    {
        title: '操作',
        dataIndex: 'action',
        width: '250px',
        scopedSlots: { customRender: 'action' },
        align: 'center'
    }
]

const statusMap = {
    0: {
        status: 'success',
        text: '节假日'
    },
    1: {
        status: 'processing',
        text: '调休'
    },
    2: {
        status: 'error',
        text: '调班'
    }
}

export default {
    name: 'TableList',
    components: {
        CreateForm
    },
    data () {
        this.columns = columns
        return {
            // create model
            visible: false,
            confirmLoading: false,
            table: {
                pageNumber: 1,
                pageSize: 100
            },
            //
            mdl: {},
            // 高级搜索 展开/关闭
            advanced: false,
            //
            data: [],
            columns,
            //
            tableKey: 0,
            formKey: 1
        }
    },
    filters: {
        statusFilter (type) {
            return statusMap[type].text
        },
        statusTypeFilter (type) {
            return statusMap[type].status
        }
    },
    created () {
        this.getList()
    },
    computed: {},
    methods: {
        // 获取菜单
        getList () {


            var params = {
                page: this.table.pageNumber,
                size: this.table.pageSize
            }

            getRoleList(params).then(res => {

                if (res.code === 0) {
                    var list = res.data.list
                    for (let i = 0; i < list.length; i++) {
                        list[i].key = list[i].id
                    }
                    this.data = list
                    this.table.total = res.data.total
                    this.tableLoading = false
                    this.reloadPage()
                    resolve()
                } else {
                    this.data = []
                }

            })
        },
        handleAdd () {
            this.mdl = {
                id: 0,
                name: '',
                menuIds: []
            }
            this.visible = true
        },
        edit (id) {
            this.mdl = {}
            // console.log(this.pagination)
            //
            var param = {
                roleId: id
            }
            return new Promise((resolve, reject) => {
                getRoleInfo(param).then(res => {
                    // console.log(res)
                    var info = res.data
                    this.mdl = {
                        id: info.id,
                        name: info.name,
                        menuIds: info.menuIds
                    }
                    console.log(this.mdl)
                    this.visible = true
                    resolve()
                }).catch(error => {
                    // console.log(error)
                    reject(error)
                })
            })
        },
        handleOk () {
            const form = this.$refs.createModal.form
            var paramsUpdate = {}
            var paramsAdd = {}
            // console.log(form)
            // this.confirmLoading = true
            form.validateFields((errors, values) => {
                if (!errors) {
                    console.log('values', values)
                    if (values.id > 0) {
                        // 修改 e.g.
                        paramsUpdate = {
                            id: values.id,
                            name: values.name,
                            menuIds: values.menuIds
                        }
                        console.log(paramsUpdate)
                        return new Promise((resolve, reject) => {
                            roleUpdate(paramsUpdate).then(res => {
                                // console.log(res)
                                // this.$refs.table.refresh()
                                if (res.code === 0) {
                                    this.$message.info('修改成功')
                                    this.getList()
                                    this.visible = false
                                    resolve()
                                } else {
                                    this.$message.error('服务器异常')
                                }
                            }).catch(error => {
                                // console.log(error)
                                reject(error)
                            })
                        })
                    } else {
                        // 新增
                        paramsAdd = {
                            name: values.name,
                            menuIds: values.menuIds
                        }
                        return new Promise((resolve, reject) => {
                            roleAdd(paramsAdd).then(res => {
                                // console.log(res)
                                // this.$refs.table.refresh()
                                if (res.code === 0) {
                                    this.$message.info('添加成功')
                                    this.getList()
                                    this.visible = false
                                    resolve()
                                } else {
                                    this.$message.error('服务器异常')
                                }
                            }).catch(error => {
                                // console.log(error)
                                reject(error)
                            })
                        })
                    }
                } else {
                    // console.log('errors')
                    this.$message.info('编辑发生错误')
                }
            })
        },
        del (id) {
            return new Promise((resolve, reject) => {
                roleDelete({ roleId: id }).then(res => {
                    // console.log(res)
                    // this.getMenu()
                    this.getList()
                    resolve()
                }).catch(error => {
                    // console.log(error)
                    reject(error)
                })
            })
        },
        handleCancel () {
            this.visible = false
            const form = this.$refs.createModal.form
            form.resetFields() // 清理表单数据（可不做）
        },
        //
        reloadPage () {
            this.tableKey += 1
            this.formKey += 1
        },
        // 分页
        onShowSizeChange (current, pageSize) {
            // console.log(current, pageSize)
            this.data = []
            this.tableLoading = true
            this.table.pageNumber = 1
            this.table.pageSize = pageSize
            this.getList()
        },
        tablePaginationChange (page) {
            // console.log(page)
            this.data = []
            this.tableLoading = true
            this.table.pageNumber = page
            this.getList()
        }
    }
}
</script>
